import { render, staticRenderFns } from "./modeling.vue?vue&type=template&id=123c15a6&"
import script from "./modeling.vue?vue&type=script&lang=js&"
export * from "./modeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports